import React from 'react';
import Panel from './Panel';
import { IconDesert } from './icons';

/** Mappe un niveau textuel (FR) vers une classe de sévérité + couleur. */
function severity(niveau = '') {
  const n = niveau.toLowerCase();
  if (n.includes('élev') || n.includes('haut')) return { cls: 'sev--high', color: '#ef4444' };
  if (n.includes('moy')) return { cls: 'sev--mid', color: '#f59e0b' };
  return { cls: 'sev--low', color: '#10b981' };
}

/** Zones mal desservies, classées par score de « désert » décroissant. */
export default function MobilityDesertsPanel({ data, delay = 0 }) {
  const deserts = [...(data?.deserts || [])].sort((a, b) => b.score - a.score);

  return (
    <Panel
      icon={IconDesert}
      title="Déserts de mobilité"
      sub={data?.echelle || '0 → 1'}
      badge={`${deserts.length} zones`}
      delay={delay}
    >
      {deserts.length === 0 && <div className="empty">Aucune zone identifiée.</div>}
      {deserts.map((d, i) => {
        const sev = severity(d.niveau);
        return (
          <div className="desert" key={d.zone_id}>
            <div className="desert__top">
              <div>
                <span className="desert__name">{d.nom}</span>{' '}
                <span className="desert__pop">
                  {d.population_estimee?.toLocaleString('fr-FR')} hab.
                </span>
              </div>
              <div className="desert__score">
                <span className={`sev-tag ${sev.cls}`}>{d.niveau}</span>
                <span className="mono" style={{ fontWeight: 700 }}>{d.score.toFixed(2)}</span>
              </div>
            </div>
            <div className="desert__bar">
              <div
                className="desert__fill"
                style={{
                  width: `${d.score * 100}%`,
                  background: sev.color,
                  animationDelay: `${delay + i * 80}ms`,
                }}
              />
            </div>
          </div>
        );
      })}
    </Panel>
  );
}
